import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { ClientHttpService } from '@data-services/http/client-http.service';
import { Project } from '@models/projects';
import { IsAnyCompanyUserResponse } from './is-any-company-user-response.model';

@Service()
export class ProjectDataService {
  private readonly http = inject(HttpService);
  private readonly clientHttp = inject(ClientHttpService);

  async getProjectsAsync(): Promise<Project[]> {
    return await this.http.getObjectAsync<Project[]>('projects');
  }

  async getClientProjectsAsync(): Promise<Project[]> {
    return await this.clientHttp.getObjectAsync<Project[]>('user/projects');
  }

  async getProjectAsync(projectId: string): Promise<Project> {
    const project = await this.http.getObjectAsync<Project>(`projects/${projectId}`);
    if (project.IsActive !== undefined) {
      project.IsInactive = project.IsActive === 'Inactive';
    }
    return project;
  }

  async getIsAnyCompanyUserAsync(projectId: string): Promise<IsAnyCompanyUserResponse> {
    return await this.clientHttp.getObjectAsync<IsAnyCompanyUserResponse>(`projects/${projectId}/isAnyCompanyUser`);
  }
}
